<template>
  <div class="tag-svg-with-color" v-html="getSvgWithColor(tag)" />
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TagSvgWithColor",
  props: {
    tag: {
      type: Object,
      required: true,
    },
    isFilled: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters("tags", ["forms"]),
  },
  methods: {
    getSvgWithColor(tag) {
      let svg = { ...this.forms.find((f) => f.name === tag.form) }.svg;
      svg = svg.replace("strokeColor", tag.color);
      if (this.isFilled) svg = svg.replace("fillColor", tag.color);
      return svg;
    },
  },
};
</script>

<style lang="less" scoped>
.tag-svg-with-color {
  display: block;
  line-height: 0;
  svg {
    display: block;
  }
}
</style>
